// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"abbd7fb5214eaae4dc4f","883":"edfa3086c6ca1bab6ed8"}[chunkId] + ".js";
};